import { ReactNode } from "react"
import { Container, Spinner } from "reactstrap"
import Breadcrumb from "Components/organisms/breadcrumb"
import Tabs from "Components/molecule/tabs"
import OpportunityDashboardContent from "Components/organisms/opportunity-dashboard/opportunity-dashboard-content"
import { OPPORTUNITY_DASHBOARD_TABS, OpportunityDashboardViews, viewFromTab } from "models/opportunity-dashboard"

interface OpportunityDashboardTemplateProps {
    filters: ReactNode
    views: OpportunityDashboardViews
    isLoading: boolean
    activeTab: string
    setActiveTab: React.Dispatch<React.SetStateAction<string>>
    actions?: ReactNode
    modal?: ReactNode
}

// Business Development → Opportunities: master filters above, one tab per report.
const OpportunityDashboardTemplate = ({ filters, views, isLoading, activeTab, setActiveTab, actions, modal }: OpportunityDashboardTemplateProps) => (
    <div className="page-content">
        <Container fluid style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            <Breadcrumb
                title="Business Development"
                breadcrumbItem="Opportunities"
                actions={actions}
            />
            <div className="section-container">
                {filters}
            </div>
            <div className="section-container opportunity-dashboard">
                <Tabs
                    headers={Object.values(OPPORTUNITY_DASHBOARD_TABS)}
                    tabs={{
                        [activeTab]: isLoading
                            ? <div className="text-center my-5"><Spinner /></div>
                            : <OpportunityDashboardContent view={viewFromTab(activeTab)} views={views} />,
                    }}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                />
            </div>
            {modal}
        </Container>
    </div>
)

export default OpportunityDashboardTemplate
